@if (isOnline) {
  <!-- Division Bottom Sheet -->
  <app-bottom-sheet
    [isOpen]="isDivisionOpen()"
    [leftButtonText]="'Cancel'"
    [rightButtonText]="'Select'"
    [leftButtonDisabled]="false"
    [rightButtonDisabled]="!drawerSelectedDivision"
    [preventOverlayClose]="true"
    [headerTemplate]="divisionHeaderTemplate"
    [contentTemplate]="divisionContentTemplate"
    (leftButtonClick)="onDivisionCancel()"
    (rightButtonClick)="onDivisionSelect()"
    data-testid="division-bottom-sheet">
  </app-bottom-sheet>

  <ng-template #divisionHeaderTemplate>
    <div class="header-content" data-testid="division-header-content">
      <span class="filter-title" data-testid="division-filter-title" id="division-filter-title">
        Select Division
      </span>
    </div>
  </ng-template>

  <ng-template #divisionContentTemplate>
    <div class="drawer-content">
      <div class="drawer-results" data-testid="division-drawer-list">
        @for (division of divisions(); track division.id) {
          <div
            class="community-option"
            (click)="drawerSelectedDivision = division"
            [class.selected]="drawerSelectedDivision?.id === division.id"
            data-testid="division-drawer-item">
            <p-radiobutton
              name="division"
              [value]="division"
              [(ngModel)]="drawerSelectedDivision">
            </p-radiobutton>
            <span class="ml-2">{{ division.name }}</span>
          </div>
        }
      </div>
    </div>
  </ng-template>

  <!-- Community Bottom Sheet -->
  <app-bottom-sheet
    [isOpen]="isOpen()"
    [leftButtonText]="'Cancel'"
    [rightButtonText]="'Select'"
    [leftButtonDisabled]="false"
    [rightButtonDisabled]="!drawerSelectedCommunity"
    [preventOverlayClose]="true"
    [headerTemplate]="headerTemplate"
    [contentTemplate]="contentTemplate"
    (leftButtonClick)="onCancel()"
    (rightButtonClick)="onSelect()"
    data-testid="filter-bottom-sheet">
  </app-bottom-sheet>

  <ng-template #headerTemplate>
    <div class="header-content" data-testid="header-content">
      <span class="filter-title" data-testid="filter-title" id="filter-title">Select Community</span>
      <input
        class="drawer-search-input"
        type="text"
        pInputText
        placeholder="Search for Community"
        (ngModelChange)="onDrawerSearchTermChange($event)"
        [(ngModel)]="communitySearchTerm"
        data-testid="community-search-input" />
    </div>
  </ng-template>

  <ng-template #contentTemplate>
    <div class="drawer-content">
      <div class="drawer-results" data-testid="community-drawer-list">
        @for (community of drawerCommunityResults(); track community.externalSalesCommunityId) {
          <div
            class="community-option"
            (click)="drawerSelectedCommunity = community"
            [class.selected]="drawerSelectedCommunity === community"
            data-testid="community-drawer-item">
            <p-radiobutton
              name="community"
              [value]="community"
              [(ngModel)]="drawerSelectedCommunity">
            </p-radiobutton>
            <span class="ml-2">{{ community.salesCommunityName }}</span>
          </div>
        }
      </div>
    </div>
  </ng-template>
}

@if (hasDetails()) {
  <!-- Search Results page -->
  <lot-search-component
    [selectedCommunity]="selectedCommunity"
    [communities]="communities"
    [searchTerm]="searchTerm"
    (searchCommunityHandler)="openCommunitySearch()"
    (backButtonPress)="toCommunitySearch()"></lot-search-component>
}
@else {
  <app-header-component></app-header-component>

  <!-- Starting search page -->
  <div class="lot-search-container" data-testid="lot-community-search-container">
    <img src="assets/icons/lot-search.svg" class="logo" />
    <span class="header-lg-bold">Find a Lot</span>

    @if (isOnline) {
      <div class="online-content">
        <div class="division-select-container">
          <div
            class="community-input"
            [class.disabled]="isDivisionDisabled()"
            data-testid="division-select"
            (click)="openDivisionSearch()">
            <span>
              {{
                selectedDivision()?.name ??
                (loadingDivisions ? "Loading Divisions..." : "Select Division")
              }}
            </span>
            <i class="pi pi-chevron-down"></i>
          </div>
        </div>

        <!-- Community picker (disabled until division selected when multiple divisions exist) -->
        <div
          class="community-input"
          [class.disabled]="isCommunityDisabled()"
          (click)="openCommunitySearch()"
          data-testid="lot-community-search-select-community">
          <span>
            {{ loading ? "Loading Communities..." : selectedCommunity()?.salesCommunityName ?? "Choose a Community" }}
          </span>
          <i class="pi pi-chevron-down"></i>
        </div>

        <input
          class="search-input"
          [class.disabled]="isSearchDisabled()"
          type="text"
          pInputText
          placeholder="Enter a lot # or address"
          [(ngModel)]="searchTerm"
          data-testid="lot-community-search-input-search" />

        <button
          (click)="executeSearch()"
          [disabled]="!selectedCommunity()"
          data-testid="lot-community-search-btn-search">
          <span class="body-md-bold">Search</span>
        </button>
      </div>
    } @else {
      <div class="offline-content" data-testid="lot-community-search-container-offline">
        <span class="offline-header">You're Offline</span>
        <span class="body-md-regular">Reconnect to find a lot</span>
      </div>
    }
  </div>
}
